import { render } from "./coming_soon.vue?vue&type=template&id=4aae0396"
import script from "./coming_soon.vue?vue&type=script&lang=js"
export * from "./coming_soon.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__